
import { BusinessUnitEntityDecorator } from '../../businessunit/model/business-unit.decorator';
import { BusinessUnit } from '../../businessunit/model/business-unit.model';
import { CostCentreEntityDecorator } from '../../costcentre/model/cost-centre.decorator';
import { CostCentre } from '../../costcentre/model/cost-centre.model';
import { AMMUNITION_STOCK_METADATA } from './ammunition-stock.metadata';
import { AmmunitionStock } from './ammunition-stock.model';
import { EntityDecorator, GenericEntityDecorator } from '@scisys-uim/uim-common';


export abstract class AmmunitionStockEntityDecoratorBase extends GenericEntityDecorator<AmmunitionStock, number> {
  constructor() {
    super(AMMUNITION_STOCK_METADATA, {
      get businessUnit(): EntityDecorator<BusinessUnit, string> {
        return new BusinessUnitEntityDecorator();
      },
      get costCentre(): EntityDecorator<CostCentre, string> {
        return new CostCentreEntityDecorator();
      }
    }, {
    });
  }
  toKeyObjectFromRouteParams(params: any): number {
    if (params == null || params.ammunitionStockId == null) {
      return null;
    }
    return parseInt(params.ammunitionStockId);
  }
  toKeyUrlPathSegments(key: number): string {
    if (key == null) {
      return null;
    }
    return '' + key;
  }
  toKeyRouteSegments(item: AmmunitionStock): any[] {
    const key: number = this.metadata?.toKeyObject(item);
    if (key == null) {
      return null;
    }
    return [key];
  }
}




